import { switchMap, debounceTime, catchError, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import get from 'lodash.get';
import Global from '../../../store/global-selectors';
import * as Actions from './customers.autocomplete.actions';
import * as Api from '../customers.api';

export const customerSearchResultsEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.INITIATE_CUSTOMER_SEARCH),
    debounceTime(1000),
    switchMap((action) => {
      const { searchTerm } = action;
      const hasCustomerManagementRole = Global.selectUserhasCustomerManagementRole(getState());
      if (!hasCustomerManagementRole || get(searchTerm, 'length', 0) < 3) {
        return EMPTY;
      }

      return Api.getCustomerSearchResults(action.searchTerm).pipe(
        mergeMap((response) => {
          return of(Actions.customerSearchSuccess(response));
        }),
        catchError(() => {
          // TODO: handle error case
          return EMPTY;
        }),
      );
    }),
  );
};
